import { Component, Input } from "@angular/core";

import { BaseSearchTabConfigModel } from "../../../../models/base-search-tab-config.model";

import { MarketplaceSearchResultsModel } from "../../models/marketplace-search-results.model";

@Component({
    selector: "pcg-ng-marketplace-search-results-list-view",
    template: require('./marketplace-search-results-list-view.component.html')
})
export class MarketplaceSearchResultsListViewComponent {
    @Input()
    public searchConfig: BaseSearchTabConfigModel;

    @Input()
    public searchResult: MarketplaceSearchResultsModel;
}
